<template>


<!-- ------------------------------ -->
<!-- ------- FOR ALL USERS -------- -->
<!-- ------------------------------ -->



<!--    voir Traits/getUser.php @alertMemberErrors()  -->
    <MyAlert v-if="$_.size($page.props.alertMemberErrors)" type="warning" icon-animated="infinite high-slower tada" dismiss dense
        :action="() => link(route('profile.show', {hash: 'UpdateProfileInformationForm'}))" icon-action="arrow_forward" label-action="Mon Profil">
        <p class="q-mb-xs">Merci de renseigner les Informations vous concernant dans votre profil.</p>
        <!-- <ul class="q-mt-xs q-mb-none">
            <li v-for="(err, key) in $page.props.alertMemberErrors" :key="key" v-show="err"><span v-html="err"></span></li>
        </ul> -->
        <p class="q-mb-none q-pl-md"><span v-html="$_.map($page.props.alertMemberErrors).join('<br>')"></span></p>
    </MyAlert>



    <MyAlert v-if=" ! user.password_modified && ! route().current('profile.show')" dismiss dense type="warning"
        no-reopen-alert-id="password_not_modified"
        :action="() => link(route('profile.show', {hash: 'passwords'}))" icon-action="arrow_forward" label-action="Mon Profil">
        <b>Pensez à modifier votre mot de passe...</b>
        <br/><small>Celui actuel vous a été fourni par E-mail et de ce fait n'est pas sécurisé...</small>
    </MyAlert>



    <MyAlert v-if="$page.props.PHASE_TEST" dismiss dense type="warning">
        <p><b>PHASE TEST en cours...</b></p>
        <div v-if="$_.size($page.props.PHASE_TEST_INFOS)">
            <ul v-if="$_.size($page.props.PHASE_TEST_INFOS.carrier)">
                <li v-for="(info, k) in $page.props.PHASE_TEST_INFOS.carrier" :key="k"><span v-html="info"></span></li>
            </ul>
        </div>
    </MyAlert>


    <!-- <MyAlert dismiss dense auto-close="6">
        Application en cours de développement... Merci de votre compréhension.
    </MyAlert> -->
    


<!-- MÀJ PRÉVUE - values in storage/app/maj.json -->

    <MyAlert v-if="utils.maj?.active" type="warning" icon-animated="infinite high-slower tada" flat>
        <Popup size="sm" class="float-right">
            <p><q-icon name="thumb_up" size="sm" color="green-5" left />Nous mettons tout en oeuvre pour terminer au plus vite et préférons agir tard le soir pour ne déranger qu'un minimum d'entre vous.</p>
            <p><q-icon name="help" size="sm" left />Dans le cas où vous attendriez pour utiliser l'application dans ces instants, vous pourrez recharger simplement la page du formulaire de connexion de temps à autres.</p>
            <div v-if="($_.size(utils.maj?.infos_admin) && (isAdmin || isComptable)) || $_.size(utils.maj?.infos)">
                <q-icon name="info" size="sm" color="info" left />Informations sur la Mise à Jour à venir :
                <ul>
                    <li v-for="(info, k) in ((isAdmin || isComptable) ? utils.maj?.infos_admin : [])" :key="k">
                        <span v-dompurify-html="info"></span>
                    </li>
                    <li v-for="(info, k) in utils.maj?.infos" :key="k">
                        <span v-dompurify-html="info"></span>
                    </li>
                </ul>
            </div>
        </Popup>
        <b>Une Mise à Jour sera effectuée le {{ utils.maj.date }} à partir de {{ utils.maj.hour }} pour une durée approximative de {{ utils.maj.duration }}.</b>
        <br/>Nos services seront temporairement inaccessibles durant cette période. Merci de votre compréhension.

    </MyAlert>

    <MyAlert v-if="$page.props.isInMaintenanceMode" type="warning" icon-animated="infinite high-slower tada" flat>
        <b>A P P L I C A T I O N &nbsp; EN &nbsp; M A I N T E N A N C E &nbsp;!</b>
        <p v-if="isMaster"><br/><q-icon name="warning" color="red-8" size="sm" left />PENSE À DÉSACTIVER LE MESSAGE DE MISE À JOUR !!!<br/>dans le fichier storage/app/maj.json</p>
    </MyAlert>

</template>

<script setup>
// import { userStore } from '@stores'
import { link } from '@helpers'
// import { computed/* , ref, reactive */ } from '@vue/reactivity'


</script>
